export default {
  data () {
    return {
      messages: {},
      ticker: false

    }
  },
  created () {
    this.$on('translation-custom', this.makeTranslation)
  },
  methods: {
    trans: function (msgId) {
      var self = this
      if (self.messages.hasOwnProperty(msgId)) {
        return self.messages[msgId]
      } else {
        return msgId
      }
    },
    makeTranslation: function (msgId, msgStr) {
      var self = this
      self.messages[msgId] = msgStr
      if (self.ticker) {
        window.clearTimeout(self.ticker)
      }
      self.ticker = window.setTimeout(function (x) {
        x.$forceUpdate()
      }, 50, self)
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/TranslationMixin.js